import { shallowEqual, useSelector } from 'react-redux';

import useActionCreator from '../../hooks/useActionCreator';
import { getNotificationPreferences, updateNotificationPreference } from './actions';

export const useNotifications = () => {
  const notificationsState = useSelector((state) => state.notifications, shallowEqual);

  return {
    ...notificationsState,
    getNotificationPreferences: useActionCreator(getNotificationPreferences),
    updateNotificationPreference: useActionCreator(updateNotificationPreference),
  };
};
